import { PackageCheck, PackageX, CircleCheck } from "lucide-react";

export const ItemsView = ({ items, rsvps }) => {
  const claimantsFor = (itemId) =>
    rsvps
      .filter((r) => (r.items || []).some((i) => i.id === itemId))
      .map((r) => r.name);

  const unclaimed = items.filter((i) => i.claim_count === 0);

  return (
    <div className="border-2 border-retro-ink bg-white shadow-retro-lg" data-testid="items-view-card">
      <div className="border-b-2 border-retro-ink bg-retro-blue p-5">
        <h2 className="font-chango text-2xl text-white drop-shadow-[1px_1px_0px_#1A2A3A]">Items &amp; Who's Bringing</h2>
      </div>

      {/* Gaps at a glance */}
      <div className="border-b-2 border-retro-ink bg-retro-cream p-5" data-testid="unclaimed-summary">
        <div className="mb-2 flex items-center gap-2">
          <PackageX className="h-5 w-5 text-retro-orange" />
          <span className="font-chango text-retro-ink">Still unclaimed ({unclaimed.length})</span>
        </div>
        {unclaimed.length === 0 ? (
          <p className="flex items-center gap-2 font-semibold text-retro-ink/80">
            <CircleCheck className="h-5 w-5 text-retro-blue" /> Everything's covered — nice!
          </p>
        ) : (
          <div className="flex flex-wrap gap-2">
            {unclaimed.map((it) => (
              <span key={it.id} className="border-2 border-retro-ink bg-white px-3 py-1 text-sm font-semibold text-retro-ink" data-testid={`unclaimed-${it.id}`}>
                {it.name}
              </span>
            ))}
          </div>
        )}
      </div>

      {/* Per-item breakdown */}
      <div className="divide-y divide-retro-ink/15">
        {items.map((it) => {
          const claimants = claimantsFor(it.id);
          const full = it.claim_count >= it.max_claims;
          return (
            <div key={it.id} className="flex flex-wrap items-start justify-between gap-3 p-4" data-testid={`items-view-row-${it.id}`}>
              <div className="min-w-[140px] flex-1">
                <div className="flex items-center gap-2">
                  {full ? <PackageCheck className="h-5 w-5 text-retro-blue" /> : <PackageX className="h-5 w-5 text-retro-ink/40" />}
                  <span className="font-semibold text-retro-ink">{it.name}</span>
                </div>
                {claimants.length > 0 && (
                  <div className="mt-2 flex flex-wrap gap-1.5" data-testid={`claimants-${it.id}`}>
                    {claimants.map((n, idx) => (
                      <span key={`${it.id}-${idx}`} className="border-2 border-retro-ink bg-retro-yellow px-2 py-0.5 text-xs font-semibold text-retro-ink">
                        {n}
                      </span>
                    ))}
                  </div>
                )}
              </div>
              <span className="border-2 border-retro-ink bg-retro-cream px-2.5 py-1 text-sm font-chango text-retro-ink" data-testid={`items-view-count-${it.id}`}>
                {it.claim_count}/{it.max_claims}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
